import React, { useState, useEffect } from 'react';
import { apiGet } from '../api/client';

function normalizeService(row) {
  return {
    ...row,
    serviceid: row.id,
    parentid: row.parentId,
  };
}

export default function AvailableServices(props) {
  const [result, setResult] = useState(
    JSON.parse(localStorage.getItem('AvailableServices')) || []
  );
  const [indexes, setIndexes] = useState([]);
  const [len, setLen] = useState();
  const [availableServices, setAvailableServices] = useState(
    JSON.parse(localStorage.getItem('AvailableServices')) || []
  );

  useEffect(() => {
    if (result.length === 0) {
      apiGet('/services', null, { auth: false })
        .then(({ data }) => {
          const rows = (data.data || []).map(normalizeService);
          setResult(rows);
          parentServicesIndex(rows);
        })
        .catch(() => alert('Something went wrong'));
    } else {
      servicesOffer();
    }
  }, [len]);

  function parentServicesIndex(res) {
    if (res.length > 0) {
      for (var i = 0; i < res.length; i++) {
        for (var j = 0; j < res.length; j++) {
          if (res[i].serviceid === res[j].parentid) {
            setIndexes((prevIndexes) => [...prevIndexes, i]);
          }
        }
      }
      setIndexes((prevIndexes) => [...removeDuplicates(prevIndexes)]);
      function removeDuplicates(data) {
        return data.filter((value, index) => data.indexOf(value) === index);
      }
    }
    setLen(res.length);
  }

  function servicesOffer() {
    if (len === result.length) {
      let x = [
        ...result.filter(function (value, index) {
          return indexes.indexOf(index) == -1;
        }),
      ];
      setAvailableServices(x);
      localStorage.setItem('AvailableServices', JSON.stringify(x));
    }
  }
  return availableServices;
}
